import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useMapContext } from "./MapContext";
import axios from "axios";
import { ElasticsearchDocument } from "./types/Elasticsearch";
import MuxPlayer from "@mux/mux-player-react";

const formatTimestamp = (timestamp: string | undefined) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp);
  return date.toLocaleString(); // Converts to local timezone and formats
};

const IssueDetails = () => {
  const {
    selectedPoint,
    setSelectedPoint,
    selectedDocument,
    setSelectedDocument,
  } = useMapContext();

  const [document, setDocument] = React.useState<ElasticsearchDocument | null>(
    null
  );

  const getDocument = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DRONESHOT_MUX_LIVE_API_URL}/incidents/${selectedDocument?.id}`
      );
      setDocument(response.data); // Assuming Elasticsearch response format
    } catch (err) {
      console.error("Failed to fetch documents:", err);
    }
  };

  useEffect(() => {
    if (selectedDocument) {
      getDocument();
    }
  }, []);

  if (!document) {
    return <Box>No Data</Box>;
  }

  const incidentTimestampEpochSeconds = Math.floor(
    new Date(document._source.timestamp).getTime() / 1000
  );

  return (
    <Box>
      <Box>{document._source.description}</Box>
      <br />
      {document._source.address && <Box>{document._source.address}</Box>}
      <Box>{formatTimestamp(document._source.timestamp)}</Box>
      <Box>Category: {document._source.category}</Box>
      <Box>Status: {document._source.status}</Box>
      <br />
      {document._source.playbackId && (
        <Box>
          <MuxPlayer
            style={{ width: "100%", height: "auto" }}
            playbackId={document._source.playbackId}
            programStartTime={incidentTimestampEpochSeconds}
          />
          <a
            href={`https://player.mux.com/${document._source.playbackId}?program-start-time=${incidentTimestampEpochSeconds}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Video
          </a>
        </Box>
      )}
    </Box>
  );
};

export default IssueDetails;
